import React, { useState } from "react";
import { examDuration } from "../constant/Constants";

const AboutAccordionPage = () => {
  const [active, setActive] = useState(1);
  const handleActive = (index) => {
    setActive((prev) => (prev === index ? 0 : index));
  };

  const faqDataFull = [
    {
      id: "One",
      ariaExpanded: "true",
      title: "What is the better practice app for exams and Olympiads?",
      content: "If you want an app that students actually enjoy using, Practido is hands-down one of the best choices. Instead of overwhelming kids with dry revision, Practido turns every <b>practice exam</b> and <u>math test</u> into a fun, motivating experience. With interactive challenges, smart analytics, and even <u>kids learning games</u>, it prepares students for both school exams and Olympiads in a way that keeps them excited, not exhausted.",
    },
    {
      id: "Two",
      ariaExpanded: "false",
      title: "What makes Practido different from other learning apps?",
      content:
        "Most learning apps push theory. <a className='link' href='https://apps.apple.com/in/app/practido-olympiad-practice/id6746647468' target='_blank'>Practido</a> focuses on mastery. What makes it stand out is its unique blend of engaging <u>educational fun games</u>, seriously effective assessments, gamification that keeps kids hooked, and practice-based learning that actually builds confidence.",
    },
    {
      id: "Three",
      ariaExpanded: "false",
      title: "What is Practido’s mission?",
      content:
        "Practido has a simple, powerful mission: to make every <b>practice exam</b> fun, not frustrating. We want kids to enjoy learning, feel confident, and stay consistent. Practido aims to transform practice into play and build lifelong learners who grow through curiosity.",
    },
    {
      id: "Four",
      ariaExpanded: "false",
      title: "What is an Olympiad exam, and why is it important?",
      content:
        "An Olympiad exam is a competitive test designed to challenge students in subjects like Maths, Science, English, and Computer. It pushes them beyond textbook knowledge and strengthens critical thinking, problem-solving, and conceptual clarity.",
    },
    {
      id: "Five",
      ariaExpanded: "false",
      title: "How does Practido empower little learners?",
      content:
        `Practido gives young learners a space where learning feels like an adventure. Through playful <u>kids learning games</u>, smart <u>gamification of learning</u>, colourful interfaces, and enjoyable practice sessions, children stay motivated while mastering real academic skills. Every <b>practice exam</b> becomes a chance to explore, every challenge feels like a game, and every improvement boosts confidence.
        `,
    },
    
  ];
  return (
    <div className="accordion" id="accordiondata">
      {faqDataFull?.map(({ id, ariaExpanded, title, content }, index) => (
        <div
          className={`card ${active === index + 1 ? "active" : ""}`}
          key={id}
        >
          <div className="card-header" id={`heading${id}`}>
            <button
              className={`btn-link btn-block text-left ${
                ariaExpanded !== "true" ? "collapsed" : ""
              }`}
              type="button"
              data-toggle="collapse"
              data-target={`#collapse${id}`}
              aria-expanded={ariaExpanded}
              aria-controls={`collapse${id}`}
              onClick={() => handleActive(index + 1)}
            >
              {title}
            </button>
          </div>
          <div
            id={`collapse${id}`}
            className={`collapse ${ariaExpanded === "true" ? "show" : ""}`}
            aria-labelledby={`heading${id}`}
            data-parent="#accordiondata"
          >
            <div
              className="card-body"
              dangerouslySetInnerHTML={{ __html: content }}
            >
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AboutAccordionPage;
